import { render, staticRenderFns } from "./entitlement-period-index.vue?vue&type=template&id=68bd3184"
import script from "./entitlement-period-index.vue?vue&type=script&lang=js"
export * from "./entitlement-period-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports